// extracted by mini-css-extract-plugin
export default {"NotFoundContainer":"NotFound_NotFoundContainer__s3XFD","NotFoundBtn":"NotFound_NotFoundBtn__XEj5a"};